module.exports = __webpack_public_path__ + "static/media/bg-blood-pressure.8da3b298.png";